import axios from "axios";
import { BASEURL } from "./baseurl";

const instance = axios.create({
  baseURL: BASEURL + "/api/Student/StudentInfo/",
  withCredentials: true,
});
instance.interceptors.request.use(
  (request) => {
    return request;
  },
  (error) => {
    window.location.href = "#/";
  },
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status !== 405) {
      //window.location.href = "/";
    }
  },
);

export default instance;
